import { render, staticRenderFns } from "./related.vue?vue&type=template&id=f052a98a&scoped=true&"
import script from "./related.vue?vue&type=script&lang=js&"
export * from "./related.vue?vue&type=script&lang=js&"
import style0 from "./related.vue?vue&type=style&index=0&id=f052a98a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f052a98a",
  null
  
)

export default component.exports